$(document).on('click', '.js_form-order-btn', orderForm);
$(document).on('click', '.js_form-order-pay-btn', orderPayForm);
$(document).on('click', '.js_form-coupon-btn', couponBtn);
$(document).on('change', '.js_order-type-ticket', orderTypeTicketChange);
$(document).on('change', '.js_select_station_from, .js_select_station_from_return', selectOrderStationFrom);
$(document).on('change', '.js_select_station_to, .js_select_station_to_return', selectOrderStationTo);
$(document).on('change', '.js_select_station-type_to, .js_select_station-type_from, .js_select_station-type_to_return, .js_select_station-type_from_return', selectOrderStationType);
$(document).on('change', '#country-codes', SelectCodeCountry);
$(document).on('click', '.js_send-to-email', sendPDFEmail);
$(document).on('click', '.js_submit-email', sendEmail);
$(document).on('click', '.modal span.close', closePopup);
$(document).on('click', '.js_order_info', orderInfo);

$(document).on('ready', readyPage);

function readyPage() {
    maskPhone();
    selectOrderStationTypeReady()
    checkAddressBlock();
}


function maskPhone() {
    var country = $('#country-codes option:selected').val();
    switchCountry(country);
}

function switchCountry(country) {
    switch (country) {
        case "us":
            $(".js_mask-phone").inputmask("+1 (999) 999-99-99");
            break;
        case "gr":
            $(".js_mask-phone").inputmask("+30 (999) 999-99-99");
            break;
        case "nl":
            $(".js_mask-phone").inputmask("+31 (999) 999-999");
            break;
        case "be":
            $(".js_mask-phone").inputmask("+32 (999) 999-999");
            break;
        case "fr":
            $(".js_mask-phone").inputmask("+33 (999) 99-99-99");
            break;
        case "es":
            $(".js_mask-phone").inputmask("+34 (999) 999-999");
            break;
        case "ie":
            $(".js_mask-phone").inputmask("+353 (999) 999-999");
            break;
        case "mt":
            $(".js_mask-phone").inputmask("+356 (99) 999-999");
            break;
        case "fi":
            $(".js_mask-phone").inputmask("+358 (999) 999-999");
            break;
        case "bg":
            $(".js_mask-phone").inputmask("+35\\9 (999) 999-999");
            break;
        case "hu":
            $(".js_mask-phone").inputmask("+36 (999) 999-999");
            break;
        case "lt":
            $(".js_mask-phone").inputmask("+370 (999) 99-999");
            break;
        case "lv":
            $(".js_mask-phone").inputmask("+371 (999) 99-9-99");
            break;
        case "ee":
            $(".js_mask-phone").inputmask("+372 (99) 99-999");
            break;
        case "md":
            $(".js_mask-phone").inputmask("+373 (999) 999-999");
            break;
        case "by":
            $(".js_mask-phone").inputmask("+375 (99) 999-99-99");
            break;
        case "ua":
            $(".js_mask-phone").inputmask("+380 (99) 999-99-99");
            break;
        case "it":
            $(".js_mask-phone").inputmask("+3\\9 (999) 999-99-99");
            break;
        case "ch":
            $(".js_mask-phone").inputmask("+41 (999) 999-999");
            break;
        case "cz":
            $(".js_mask-phone").inputmask("+420 (999) 999-999");
            break;
        case "sk":
            $(".js_mask-phone").inputmask("+421 (999) 999-999");
            break;
        case "au":
            $(".js_mask-phone").inputmask("+43 (999) 999-99-99");
            break;
        case "gb":
            $(".js_mask-phone").inputmask("+44 (999) 999-99-99");
            break;
        case "dk":
            $(".js_mask-phone").inputmask("+45 (999) 99-9-99");
            break;
        case "se":
            $(".js_mask-phone").inputmask("+46 (999) 999-999");
            break;
        case "no":
            $(".js_mask-phone").inputmask("+47 (999) 99-9-99");
            break;
        case "pl":
            $(".js_mask-phone").inputmask("+48 (999) 999-999");
            break;
        case "de":
            $(".js_mask-phone").inputmask("+4\\9 (999) 999-999-99");
            break;
        case "ru":
            $(".js_mask-phone").inputmask("+7 (999) 999-99-99");
            break;
        case "tr":
            $(".js_mask-phone").inputmask("+\\90 (999) 999-99-99");
            break;
        case "ae":
            $(".js_mask-phone").inputmask("+\\971 (9)9-999-99-99");
            break;
        case "il":
            $(".js_mask-phone").inputmask("+\\972 (99) 999-99-99");
            break;
        case "tj":
            $(".js_mask-phone").inputmask("+\\9\\92 (999) 999-999");
            break;
        case "tm":
            $(".js_mask-phone").inputmask("+\\9\\93 (999) 999-999");
            break;
        case "az":
            $(".js_mask-phone").inputmask("+\\9\\94 (999) 999-999");
            break;
        case "ge":
            $(".js_mask-phone").inputmask("+\\9\\95 (999) 999-999");
            break;
        case "kg":
            $(".js_mask-phone").inputmask("+\\9\\96 (999) 999-999");
            break;
        case "uz":
            $(".js_mask-phone").inputmask("+\\9\\98 (999) 999-999");
            break;
    }
}

function SelectCodeCountry() {
    switchCountry($(this).val());
}

maskPhone();

function selectOrderStationFrom() {
    let data = {},
        url = $(this).data('url'),
        returnTxt = $(this).data('return') ? '_return' : '';

    data['station_from_id'] = $(this).val();
    data['station_to_id'] = $("[name='station_to_id" + returnTxt + "']").val();
    data['destination'] = 'from';
    data['return_ticket'] = $(this).data('return');

    let is_return = data['return_ticket'] ? '.return-tickets' : '.direct-tickets';

    visibleAddressBlock($(this).find(':selected').data('is_default'), $($(this).data('address-block')))

    $.get(url, data).success(function (data) {
        if (data.result == 'error') {
            toastr.error(data.message);
            $("[name='station_from_id" + returnTxt + "']").val(data.station_from_id);
            $("[name='station_to_id" + returnTxt + "']").val(data.station_to_id);
        } else {
            toastr.success(data.message);
            $('.js_time_from' + returnTxt).html(data.DateFrom);
            $('.js_time_to' + returnTxt).html(data.DateTo);
            $('.js_order-prices' + is_return).html(data.htmlPrices);
        }
    });
}

function selectOrderStationTo() {
    let data = {},
        url = $(this).data('url'),
        returnTxt = $(this).data('return') ? '_return' : '';

    data['station_from_id'] = $("[name='station_from_id" + returnTxt + "']").val();
    data['station_to_id'] = $(this).val();
    data['destination'] = 'to';
    data['return_ticket'] = $(this).data('return');

    let is_return = data['return_ticket'] ? '.return-tickets' : '.direct-tickets';

    visibleAddressBlock($(this).find(':selected').data('is_default'), $($(this).data('address-block')))

    $.get(url, data).success(function (data) {
        if (data.result == 'error') {
            toastr.error(data.message);
            $("[name='station_from_id" + returnTxt + "']").val(data.station_from_id);
            $("[name='station_to_id" + returnTxt + "']").val(data.station_to_id);
        } else {
            toastr.success(data.message);
            $('.js_time_from' + returnTxt).html(data.DateFrom);
            $('.js_time_to' + returnTxt).html(data.DateTo);
            $('.js_order-prices' + is_return).html(data.htmlPrices);
        }
    });
}

function visibleAddressBlock(defaultParam, addressBlock) {
    if (addressBlock.length) {
        if (defaultParam) {
            if (!addressBlock.children('input').length) {
                addressBlock.prepend('<input style="width: 90%; height: 33px; box-sizing: border-box; line-height: 32px; padding-left: 5px;" autocomplete="address-line" type="text" id="' + addressBlock.data('id') + '" class="input" name="' + addressBlock.data('name') + '" value="' + addressBlock.data('value') + '" placeholder="' + addressBlock.data('placeholder') + '">').show();
                addressBlock.siblings('[name*="is_new_stations"]').val(1);
            } else {
                addressBlock.children('input').val(addressBlock.data('value')).prop('placeholder', addressBlock.data('placeholder'));
            }
        } else {
            addressBlock.hide().children('input').remove();
            addressBlock.siblings('[name*="is_new_stations"]').val(0);
        }
    }
}

function checkAddressBlock() {
    let fields = [
        $('[name="station_from_id"]'),
        $('[name="station_to_id"]'),
        $('[name="station_from_id_return"]'),
        $('[name="station_to_id_return"]')
    ];

    $.each(fields, function () {
        let self = $(this);

        if (self.length) {
            visibleAddressBlock(self.find(':selected').data('is_default'), $(self.data('address-block')))
        }
    })
}

function selectOrderStationTypeReady() {
    let filters = [
        $('.js_select_station-type_to:checked'),
        $('.js_select_station-type_from:checked'),
        $('.js_select_station-type_to_return:checked'),
        $('.js_select_station-type_from_return:checked')
    ];
    
    $.each(filters, function () {
        let self = $(this);

        if (self.length) {
            let select = $('.' + self.attr('class').replace('-type', ''));

            selectOrderStationOptgroup(select);
        }
    })
}
function selectOrderStationType() {
    let self = $(this),
        select = $('.' + self.attr('class').replace('-type', '')),
        disabled = parseInt(self.val()) - 1;

    select.find('option').each(function () {
        let self = $(this);

        self.data('is_default') ? self.prop('hidden', !disabled) : self.prop('hidden', disabled);
    });

    selectOrderStationOptgroup(select);

    select.find('option:not([hidden])').eq(0).prop('selected', 1);
    select.trigger('change');
}
function selectOrderStationOptgroup(select) {
    select.find('optgroup').each(function () {
        let self = $(this);

        (self.find('option[hidden]').length == self.find('option').length) ? self.prop('hidden', true) : self.removeAttr('hidden');
    })
}

function couponBtn() {
    let url = $(this).data('url');
    let code = $('.js_form-coupon-code').val();
    let $prices = $('.js_order-prices');
    $.get(`${url}?unique_code=${code}&document_type=receipt`, (response) => {
        if (response.result == 'success') {
            toastr.success(response.message);
        } else {
            toastr.error(response.message);
        }
        $prices.html(response.view);
    })
}

function orderForm() {
    const $docType = $('#doc_type');
    const $docNumber = $('#doc_number');

    if ($docType.val() === '0' && $docNumber.val().replace(' ', '').length != 10) {
        toastr.error('Номер документа имеет неверный формат (нужно 10 цифр)');
        $('html, body').animate({ scrollTop: 0 }, 800);
        return;
    }

    let $form = $('.js_form-order');
    $form.submit();
    var fewSeconds = 5;
    var btn = $(this);
    btn.prop('disabled', true);
    setTimeout(function () {
        btn.prop('disabled', false);
    }, fewSeconds * 1000);
}

function orderPayForm() {
    $('<input>').attr({ type: 'hidden', id: 'is_pay', name: 'is_pay', value: 1 }).appendTo('form');
    orderForm();
}

function orderTypeTicketChange() {
    let self = $(this),
        className = self.attr('class');

    getOrderTickets('direct', className);
    if (self.data('has_return')) {
        getOrderTickets('return', className);
    }
}
function getOrderTickets(direction, className) {
    let tickets = $('.js_order-prices.' + direction + '-tickets'),
        data = {
            dir: direction
        };

    $('.' + className + ':checked').each(function () {
        let self = $(this),
            name = self.attr('name'),
            value = self.val()

        data[name] = value;
    })

    $.get('/order/type-ticket', data, function (response) {
        if (response.result == 'success') {
            toastr.success(response.message);
        } else {
            toastr.error(response.message);
        }
        tickets.html(response.view);
        $('#total-ticket-' + direction).text(parseFloat(response.total).toFixed(2));

        setTicketType('child');
        setTicketType('pensioner');
    });
}

function setTicketType(keyword) {
    let Ids = [];

    $('input[name="count_' + keyword + '"]').val($('.js_order-type-ticket[value="' + keyword + '"]:checked').length);
    $('.js_order-type-ticket[value="' + keyword + '"]').each((index, element) => {
        if (element.checked) {
            Ids.push(index);
        }
    });
    $('input[name="' + keyword + 'Ids"]').val(Ids.toString());
}

function closePopup() {
    let $popup = $('#js_email-popup');
    $popup.html('');
}

function sendPDFEmail() {
    let id = $(this).attr('data-order-id');
    let url = '/profile/generate-pdf-to-email/' + id;
    let $popup = $('#js_email-popup');
    let $this = this;

    $("#js_ticket-active").attr("data-ticket-id", id);

    let button_message_waiting = 'Обрабатывается...';
    let button_message_again = 'Отправить еще раз?';

    $($this).html(button_message_waiting);
    $.get(url, (response) => {
        if (response.result == 'success') {
            toastr.success(response.message);
        } else {
            toastr.error(response.message);
            $popup.html(response.view);
            $('#popup1').show();
        }
        $($this).html(button_message_again);
    })
}

function sendEmail() {

    let url = '/profile/update/email';
    let email = $('#settings-input').val();

    $.post(url, {
        email: email
    }, function (data) {
        if (data.result == 'error') {
            toastr.error(data.message);
        } else {
            toastr.success('Данные успешно обновлены');
            closePopup();
            $(".js_send-to-email").trigger("click")
        }
    });
}

function orderInfo() {
    let url = '/api/v1/client/order/info';
    let slug = $('#order-slug').val();

    $.post(url, {
        slug: slug
    }, function (data) {
        if (data.result == 'error') {
            toastr.error(data.message);
        } else {
            $('#info-date').text(data.stationFromTime);
            $('#info-route').text(data.routeName);
            $('#info-driver').text(data.driverName);
            $('#info-driver-phone').text(data.driverNumber);
            $('#info-car').text(data.busName);
            let status = data.status;
            let pay = data.typePay;
            if (status === 'active') {
                $('#info-status').text('Активный заказ');
                switch (pay) {
                    case 'waiting':
                        $('#info-pay').text('Ждет оплаты');
                        break;
                    case 'cash-payment':
                        $('#info-pay').text('Оплата наличными');
                        break;
                    case 'success':
                        $('#info-pay').text('Оплачено');
                        break;
                }
            }
            if (status === 'disable') {
                $('#info-status').text('Заказ отменен');
            }
        }
    });
}
